/**
 * Lazy-loaded actions to prevent them from being included in the main bundle
 * Each action is only loaded when its specific route is accessed
 */

// Authentication actions
export const loginAction = async (args: any) => {
    const module = await import("../pages/auth/Login");
    return module.action ? await module.action(args) : null;
};

export const registerAction = async (args: any) => {
    const module = await import("../pages/auth/Register");
    return module.action ? await module.action(args) : null;
};

export const registerSaasAction = async (args: any) => {
    const module = await import("../pages/auth/RegisterSaas");
    return module.action ? await module.action(args) : null;
};

export const activateAccountAction = async (args: any) => {
    const module = await import("../pages/auth/ActivateAccount");
    return module.action ? await module.action(args) : null;
};

export const activateParentAccountAction = async (args: any) => {
    const module = await import("../pages/auth/ActivateParentAccount");
    return module.action ? await module.action(args) : null;
};

export const resetPasswordAction = async (args: any) => {
    const module = await import("../pages/auth/ResetPassword");
    return module.action ? await module.action(args) : null;
};

export const changePasswordAction = async (args: any) => {
    const module = await import("../pages/auth/ChangePassword");
    return module.action ? await module.action(args) : null;
};

export const grantKedAccessToStudentAction = async (args: any) => {
    const module = await import("../pages/auth/GrantProductAccessToStudentPage");
    return module.action ? await module.action(args) : null;
};

// User content actions
export const contactAction = async (args: any) => {
    const module = await import("../pages/user/Contact");
    return module.action ? await module.action(args) : null;
};

export const deleteArticleAction = async (args: any) => {
    const module = await import("../pages/user/blog/BlogPage");
    return module.deleteAction ? await module.deleteAction(args) : null;
};

export const settingsAction = async (args: any) => {
    const module = await import("../pages/user/settings/SettingsPage");
    return module.settingsAction ? await module.settingsAction(args) : null;
};

// Learning course actions
export const learningCourseEnrollAction = async (args: any) => {
    const module = await import("../pages/user/learning-course/LearningCourseEnrollPage");
    return module.action ? await module.action(args) : null;
};

export const coursePurchaseAction = async (args: any) => {
    const module = await import("../pages/user/learning-course/LearningCoursePurchasePage");
    return module.action ? await module.action(args) : null;
};

export const extraordinarySupportPurchaseAction = async (args: any) => {
    const module = await import("../pages/user/extraordinary-support/ExtraordinarySupportPurchasePage");
    return module.action ? await module.action(args) : null;
};

export const completeEpisodeAction = async (args: any) => {
    const module = await import("../components/user/learning-course/LearningCourseEpisodeComponent");
    return module.action ? await module.action(args) : null;
};

// Funnel actions
export const saveWebinarQuizResultsOrSchedulePhoneNotificationAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/WebinarOptInConfirmationPage");
    return module.action ? await module.action(args) : null;
};

// Funnel actions
export const saveWebinarQuizResultsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/WebinarOptInJustInTimeConfirmationPage");
    return module.action ? await module.action(args) : null;
};

export const launchOptInAction = async (args: any) => {
    const module = await import("../pages/funnel/launch/launchAction");
    return module.launchOptInAction ? await module.launchOptInAction(args) : null;
};

export const funnelKedWebinarOptInAction = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelKedWebinarOptInAction ? await module.funnelKedWebinarOptInAction(args) : null;
};

export const funnelKedWebinarOptInV1Action = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelKedWebinarOptInV1Action ? await module.funnelKedWebinarOptInV1Action(args) : null;
};

export const funnelKedWebinarOptInV2Action = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelKedWebinarOptInV2Action ? await module.funnelKedWebinarOptInV2Action(args) : null;
};

export const funnelKedWebinarOptInV3Action = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelKedWebinarOptInV3Action ? await module.funnelKedWebinarOptInV3Action(args) : null;
};

export const funnelMWParentOptInAction = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelMWParentOptInAction ? await module.funnelMWParentOptInAction(args) : null;
};

// English webinar actions
export const funnelEnWebinarOptInAction = async (args: any) => {
    const module = await import("../pages/funnel/optin/action");
    return module.funnelEnWebinarOptInAction ? await module.funnelEnWebinarOptInAction(args) : null;
};

export const purchaseEnWebinarAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseEnWebinarAction");
    return module.purchaseEnWebinarAction ? await module.purchaseEnWebinarAction(args) : null;
};

export const saveEnWebinarQuizResultsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/en/EnWebinarOptInConfirmationPage");
    return module.action ? await module.action(args) : null;
};

export const saveEnWebinarJitQuizResultsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/en/EnWebinarOptInJustInTimeConfirmationPage");
    return module.action ? await module.action(args) : null;
};

// Purchase actions
export const purchaseWebinarAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseWebinarAction ? await module.purchaseWebinarAction(args) : null;
};

export const purchaseWebinarInstallmentAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarInstallmentAction");
    return module.purchaseWebinarInstallmentAction ? await module.purchaseWebinarInstallmentAction(args) : null;
};

export const purchaseKedFromWebinarSalesPageAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseKedFromWebinarSalesPageAction ? await module.purchaseKedFromWebinarSalesPageAction(args) : null;
};

export const purchaseKedFromRadsAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseKedFromRadsAction ? await module.purchaseKedFromRadsAction(args) : null;
};

export const purchaseKedFromNewsletterAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseKedFromNewsletterAction ? await module.purchaseKedFromNewsletterAction(args) : null;
};

export const purchasePedFromSalesPageAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchasePedFromSalesPageAction ? await module.purchasePedFromSalesPageAction(args) : null;
};

export const purchaseZnFromSalesPageAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/zn/purchaseZnAction");
    return module.purchaseZnFromSalesPageAction ? await module.purchaseZnFromSalesPageAction(args) : null;
};

export const purchaseKedFromPedCourseSalesPage = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseKedFromPedCourseSalesPage ? await module.purchaseKedFromPedCourseSalesPage(args) : null;
};

export const purchaseNewsletterKedAction = async (args: any) => {
    const module = await import("../pages/newsletter/purchaseNewsletterKedAction");
    return module.purchaseNewsletterKedAction ? await module.purchaseNewsletterKedAction(args) : null;
};

export const purchaseDzienDzieckaAction = async (args: any) => {
    const module = await import("../pages/newsletter/purchaseDzienDzieckaAction");
    return module.purchaseDzienDzieckaAction ? await module.purchaseDzienDzieckaAction(args) : null;
};

export const purchaseNewsletterKedReofferAction = async (args: any) => {
    const module = await import("../pages/newsletter/purchaseNewsletterKedReofferAction");
    return module.purchaseNewsletterKedReofferAction ? await module.purchaseNewsletterKedReofferAction(args) : null;
};

export const kedV1PurchaseAction = async (args: any) => {
    const module = await import("../pages/newsletter/KedV1PurchasePage");
    return module.kedV1PurchaseAction ? await module.kedV1PurchaseAction(args) : null;
};

export const purchaseBlackFridayAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseBlackFridayAction ? await module.purchaseBlackFridayAction(args) : null;
};

export const purchaseChristmasAction = async (args: any) => {
    const module = await import("../pages/funnel/after-optin/webinar/purchaseWebinarAction");
    return module.purchaseChristmasAction ? await module.purchaseChristmasAction(args) : null;
};

export const purchaseSpcAction = async (args: any) => {
    const module = await import("../pages/funnel/system-planowania-czasu/purchaseSpcAction");
    return module.purchaseSpcAction ? await module.purchaseSpcAction(args) : null;
};

// Newsletter actions
export const newsletterFormAction = async (args: any) => {
    const module = await import("../components/user/newsletter/NewsletterForm");
    return module.action ? await module.action(args) : null;
};

export const cancelNewsletterFormAction = async (args: any) => {
    const module = await import("../components/user/newsletter/CancelNewsletter");
    return module.action ? await module.action(args) : null;
};

// Other component actions
export const purchaseTokensAction = async (args: any) => {
    const module = await import("../components/user/ai/pricing/chat/ChatPricing");
    return module.action ? await module.action(args) : null;
};

export const sendFeedbackAction = async (args: any) => {
    const module = await import("../components/user/feedback/FeedbackModal");
    return module.action ? await module.action(args) : null;
};

export const mandatoryFeedbackCourseAction = async (args: any) => {
    const module = await import("../components/user/learning-course/content/MandatoryFeedbackCourseModal");
    return module.mandatoryFeedbackCourseAction ? await module.mandatoryFeedbackCourseAction(args) : null;
};

export const mandatoryEndCourseFeedbackAction = async (args: any) => {
    const module = await import("../components/user/learning-course/content/MandatoryEndCourseFeedbackModal");
    return module.mandatoryEndCourseFeedbackAction ? await module.mandatoryEndCourseFeedbackAction(args) : null;
};

// Logout action - this one can stay as direct import since it's small and commonly used
export const logoutAction = async () => {
    const module = await import("../components/ui/header/Header");
    return module.logoutAction ? await module.logoutAction() : null;
};